import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** 패딩 비활성화 */
  noPadding?: boolean
  /** 클릭 가능 여부 (hover 효과) */
  clickable?: boolean
}

/**
 * 카드 컨테이너 컴포넌트 v2.0
 *
 * - 라운드: 16px
 * - 그림자: 소프트 레이어드
 * - 패딩: 20px
 * - 보더: 없음 (그림자로 깊이감 표현)
 * - 호버: 리프트 효과 (translateY + 그림자 강화)
 */
const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ noPadding = false, clickable = false, className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'rounded-[var(--radius-card)] bg-white shadow-[var(--shadow-card)]',
          !noPadding && 'p-[var(--spacing-card)]',
          clickable &&
            'cursor-pointer transition-all duration-200 hover:shadow-[var(--shadow-card-hover)] hover:-translate-y-0.5 active:translate-y-0 active:shadow-[var(--shadow-card)]',
          className
        )}
        {...props}
      >
        {children}
      </div>
    )
  }
)

Card.displayName = 'Card'

export default Card
